export const parseNumber = function(val, fixed = 2) {
  if (typeof val === 'number') {
    return val;
  }
  if (typeof val === 'string') {
    let val1 = val.replace(/,/g, '.').replace(/ /g, '');
    let parsed = 0;
    if (val1.indexOf('.') === -1) {
      parsed = parseInt(val1);
    } else {
      parsed = parseFloat(val1).toFixed(fixed);
    }
    return isNaN(parsed) ? 0 : parsed;
  }
  return 0;
}